import React from 'react';

export default function Question() {
  return (
    <svg
      height='18.037'
      id='question-circle'
      viewBox='0 0 18.037 18.037'
      width='18.037'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M10.522,14.655V12.4a.362.362,0,0,0-.376-.376H7.891a.362.362,0,0,0-.376.376v2.255a.362.362,0,0,0,.376.376h2.255a.362.362,0,0,0,.376-.376Zm3.006-7.891a3.15,3.15,0,0,0-.652-1.914A4.572,4.572,0,0,0,9.254,3.006,4.8,4.8,0,0,0,4.9,5.507.335.335,0,0,0,4.991,6l1.55,1.174a.331.331,0,0,0,.223.071A.346.346,0,0,0,7.058,7.1a5.838,5.838,0,0,1,1.01-1.08,1.709,1.709,0,0,1,1.01-.282,1.721,1.721,0,0,1,1,.305.855.855,0,0,1,.44.693,1.053,1.053,0,0,1-.235.716,2.379,2.379,0,0,1-.8.529A4.018,4.018,0,0,0,8.133,9a2.178,2.178,0,0,0-.617,1.474V10.9a.362.362,0,0,0,.376.376h2.255a.362.362,0,0,0,.376-.376,1.118,1.118,0,0,1,.253-.581,1.982,1.982,0,0,1,.64-.581q.376-.211.575-.335a4.969,4.969,0,0,0,.54-.411,2.717,2.717,0,0,0,.523-.564,3.108,3.108,0,0,0,.329-.71,2.954,2.954,0,0,0,.147-.951Zm4.509,2.255a8.823,8.823,0,0,1-1.209,4.527,8.977,8.977,0,0,1-3.282,3.282,8.823,8.823,0,0,1-4.527,1.209,8.823,8.823,0,0,1-4.527-1.209,8.977,8.977,0,0,1-3.282-3.282A8.823,8.823,0,0,1,0,9.019,8.823,8.823,0,0,1,1.209,4.492,8.977,8.977,0,0,1,4.492,1.209,8.823,8.823,0,0,1,9.019,0a8.823,8.823,0,0,1,4.527,1.209,8.977,8.977,0,0,1,3.282,3.282A8.823,8.823,0,0,1,18.037,9.019Z'
        data-name='question-circle'
        fill='#caced5'
        id='question-circle-2'
      />
    </svg>
  );
}
